<template>
  <div>
    <!-- INK SIGNATURE MODAL -->
    <div class="text-center">
      <v-dialog v-model="dialog_ink_signature" max-width="850px" scrollable persistent>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-card
            style="padding: 3%;"
          >
            <v-card-title>
              <v-toolbar color="white">
                <v-toolbar-title :style="{ color: parentColor }">
                  Add Signature
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                  icon="mdi-close"
                  :color="parentColor"
                  @click="
                    close();
                    reset();
                  "
                ></v-btn>
              </v-toolbar>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="4" md="4" sm="12">
                  <v-card class="text-center" elevation="1" height="350px">
                    <v-card-title>Select Signature</v-card-title>
                    <v-card-content>
                      <v-list v-model="selected" select-strategy="leaf" v-if="user_ink_signatures && user_ink_signatures.length > 0">
                        <v-list-item
                          v-for="item in user_ink_signatures"
                          :key="item.signatureId"
                          active-class="text-success"
                        >
                          <v-card class="cursor-pointer" @click="setSignature(item)">
                            <v-img
                              class="bg-grey-lighten-2"
                              height="150"
                              :src="item.signatureUrl + '&t=' + item.itemUpdatedOn"
                              cover
                            ></v-img>
                            <v-card-title class="text-h6">
                              {{ formatDate(item?.itemUpdatedOn) }}
                            </v-card-title>
                          </v-card>
                        </v-list-item>
                      </v-list>
                      <v-list v-model="selected" select-strategy="leaf" v-else>
                        <v-list-item active-class="text-success">
                          <p style="margin-top: 0px; height: auto;" class="text-center">
                            No Signatures Found
                          </p>
                        </v-list-item>
                      </v-list>
                    </v-card-content>
                  </v-card>
                </v-col>
                <v-col cols="8" md="8" sm="12" v-if="renderComponent">
                  <v-card class="text-center" elevation="1">
                    <v-card-title>Draw Signature Here</v-card-title>
                    <v-card-content>
                      <vue-signature
                        ref="user_ink_signature"
                        :width="500"
                        :height="300"
                        :penColor="option.penColor"
                        :backgroundColor="option.backgroundColor"
                        @stroke-end="updateUserSignatureVector"
                      ></vue-signature>
                    </v-card-content>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                @click="
                  close();
                  reset();
                "
                variant="flat"
                elevation="1"
              >
                Close
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn-group
                variant="outlined"
                divided
              >
                <v-btn
                  color="error"
                  @click="
                    clearSignature();
                  "
                  style="float: right;"
                  variant="flat"
                  elevation="1"
                  :loading="store.loading"
                >
                  Clear
                </v-btn>
                <v-menu :close-on-content-click="false">
                  <template v-slot:activator="{ props }">
                    <v-btn 
                      icon="mdi-select-color" 
                      variant="tonal" 
                      color="warning" 
                      v-bind="props"
                    ></v-btn>
                  </template>
                  <div class="d-flex justify-space-around">
                    <v-color-picker
                      v-model="picker"
                      elevation="0"
                    ></v-color-picker>
                  </div>
                </v-menu>
                <v-btn
                  :color="parentColor"
                  @click="
                    saveSignature();
                  "
                  style="float: right;"
                  variant="flat"
                  elevation="1"
                  :loading="store.loading"
                >
                  Submit
                </v-btn>
              </v-btn-group>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </div>
  </div>
</template>

<script>
var moment = require("moment");
import axios from "axios";
import UserData from "../repository/UserData";
import { useAuthStore } from "../../stores/auth";
import { useIndexStore } from "../../stores/index";
import { useAlertStore } from "../../stores/alert";
import GlobalMethods from "../repository/GlobalMethods";
import VueSignature from "./SignaturePad.vue";

export default {
  name: "InkSignatureModal",

  components: {
    VueSignature,
  },

  props: {
    parentColor: {
      type: String,
      default: 'rgb(71, 183, 83)',
      required: false,
    },
  },

  watch: {
    picker: {
      handler(val) {
        this.option.penColor = val;
        this.recolorSignature(this.option.penColor);
      },
    },
  },
  
  data: () => ({
    renderComponent: true,
    // Start pad
    disabled: false,
    userSignature: null,
    // End pad
    mode: 'rgb',
    selected: [],
    picker: null,
    valid: false,
    dialog: false,
    interestDisclosed: "",
    interestConflict: "",
    hasConflict: false,
    confirm: false,
    comments: "",
    conditions: "",
    password: "",
    rules: {
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 3) || "Min 3 characters",
      ],
      selectRules: [(v) => !!v || "Select is required"],
      textRules: [
        v => !!v || 'Field is required',
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
      characterRules: [
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
    },
    token: localStorage.getItem("token") ? JSON.stringify(localStorage.getItem("token")).slice(1, -1) : "",
    auth: useAuthStore(),
    store: useIndexStore(),
    alert: useAlertStore(),
    globalMethods: GlobalMethods,
    option: {
      penColor: "#000000",
      backgroundColor: "#ffffff",
    },
    signaturePadKey: 0,
  }),

  computed: {
    user() {
      return this.auth.getLoggedInUser;
    },

    user_ink_signatures: {
      get: function () {
        return this.store.getUserInkSignatures;
      },
      set: function (value) {
        this.store.setUserInkSignatures(value);
      }
    },

    selected_ink_signature: {
      get: function () {
        return this.store.getSelectedInkSignature;
      },
      set: function (value) {
        this.store.setSelectedInkSignature(value);
      }
    },
    
    dialog_ink_signature: {
      get: function () {
        return this.store.getDialogInkSignature;
      },
      set: function (value) {
        this.store.setDialogInkSignature(value);
      }
    },

    current_approval: {
      get: function () {
        return this.store.getCurrentApproval;
      },
      set: function (value) {
        this.store.setCurrentApproval(value);
      }
    },

    verified: {
      get: function () {
        return this.store.getVerified;
      },
      set: function (value) {
        this.store.setVerified(value);
      }
    },
  },
  
  methods: {
    hex2rgb(hex) {
      return ['0x' + hex[1] + hex[2] | 0, '0x' + hex[3] + hex[4] | 0, '0x' + hex[5] + hex[6] | 0];
    },

    recolorSignature(newColor) {
      if (!this.$refs.user_ink_signature) return;

      const pad = this.$refs.user_ink_signature.signaturePad;

      if (pad.isEmpty() && this.isCanvasBlank()) {
        this.alert.showError('Canvas is blank.');
        return;
      }

      const vectorData = pad.toData();

      if (!vectorData || !vectorData.length) {
        this.alert.showInfo('Cannot recolor: signature was loaded from an image. Clear the image canvas first to draw your new signature.');
        return;
      } 

      const recoloredData = vectorData.map(group => ({
        ...group,
        penColor: newColor,
        points: group.points.map(p => ({ ...p }))
      }));

      pad.fromData(recoloredData, { clear: true });
    },

    updateUserSignatureVector() {
      if (this.$refs.user_ink_signature && this.$refs.user_ink_signature.toData) {
        this.userSignature = this.$refs.user_ink_signature.toData();
      }
    },

    async setSignature(signature) {
      this.store.setLoading(true);

      try {
        const dataUrl = await this.fetchImageAsDataURL(signature.signatureUrl);

        this.$nextTick(() => {
          this.clearSignature();
          this.useSignatureFromDataURL(dataUrl);
          this.selected_ink_signature = Object.assign({}, signature);
        });
      } catch (e) {
        this.alert.showError('Failed to load signature image.');
      }

      this.store.setLoading(false);
    },

    saveSignature() {
      var pad = this.$refs.user_ink_signature.signaturePad;

      if (pad.isEmpty() && this.isCanvasBlank()) {
        this.alert.showError('Please provide a valid signature.');
        return;
      }

      var _this = this;
      var png = _this.$refs.user_ink_signature.toDataURL();
      var jpeg = _this.$refs.user_ink_signature.toDataURL("image/jpeg");
      var svg = _this.$refs.user_ink_signature.toDataURL("image/svg+xml");

      if (png && svg && jpeg) {
        this.addUserInkSignature(png);

        // reset user signature
        this.userSignature = null;
      }
    },

    isCanvasBlank() {
      const pad = this.$refs.user_ink_signature.signaturePad;

      let canvas = this.$refs.user_ink_signature.$refs?.canvas;
      if (!canvas && pad && pad._canvas) {
        canvas = pad._canvas;
      }

      if (!canvas) return true;

      const blank = document.createElement('canvas');
      blank.width = canvas.width;
      blank.height = canvas.height;
      const ctx = blank.getContext('2d');
      ctx.fillStyle = this.option.backgroundColor || "#fff";
      ctx.fillRect(0, 0, blank.width, blank.height);

      return canvas.toDataURL() === blank.toDataURL();
    },

    useSignatureFromDataURL(dataUrl) {
      if (this.$refs.user_ink_signature) {
        const pad = this.$refs.user_ink_signature.signaturePad;

        let canvas = this.$refs.user_ink_signature.$refs?.canvas;
        if (!canvas && pad && pad._canvas) {
          canvas = pad._canvas;
        }

        if (!canvas) {
          this.alert.showError('Canvas not found.');
          return;
        }

        const img = new window.Image();
        img.onload = function () {
          pad.clear();
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        };

        img.src = dataUrl;
      }
    },

    async fetchImageAsDataURL(url) {
      const response = await fetch(url, { mode: 'cors' });
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },

    clearSignature() {
      if (this.$refs.user_ink_signature) {
        this.$nextTick(() => {
          this.userSignature = null;
          this.$refs.user_ink_signature.clear();
        });
      }
    },

    formatDate(date) {
      return moment.unix(date).format("DD MMM YYYY");
    },

    validate() {
      return this.$refs.form.validate();
    },

    resetForm() {
      return this.$refs.form.reset();
    },

    resetValidation() {
      return this.$refs.form.resetValidation();
    },

    close() {
      this.store.setDialogInkSignature(false);
    },

    reset() {
      this.comments = "";
      this.conditions = "";
      this.password = "";
      this.interestDisclosed = "";
      this.interestConflict = "";
      this.confirm = false;
      this.hasConflict = false;
      document.querySelector('html').classList.remove('v-overlay-scroll-blocked');
    },

    addUserInkSignature(signature) {
      this.valid = this.validate();
      if (this.valid) {
        this.store.setLoading(true);

        const formData = new FormData();

        let userId = UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId;
        var fileName = userId + '-' + Date.now() + '.png';

        formData.append("userId", userId);
        formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
        formData.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
        formData.append("model", "addUserInkSignature");
        formData.append("fileName", fileName)
        formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);

        const blob = this.dataURLtoBlob(signature);
        formData.append("file", blob, fileName);

        axios.post(UserData.getBaseUrl(), formData).then((response) => {
          this.store.setLoading(false);

          if (response.data.success == 1) {
            this.selected_ink_signature = Object.assign({}, response?.data?.data);
            this.verified = true;
            this.alert.showSuccess(response.data.message);
            document.querySelector('html').classList.remove('v-overlay-scroll-blocked');
            this.close();
            this.reset();
          } else {
            this.verified = false;
            this.alert.showError(response?.data?.message ?? 'Something Went Wrong');
          }
        })
        .catch((e) => {
          this.store.setLoading(false);
          console.log("Error", e);
        });
      }
    },

    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);

      while(n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new Blob([u8arr], { type: mime});
    },
  },
};
</script>

<style scoped>
.list-striped a {
  text-decoration: none;
  color: #000;
}

.list-striped a:hover {
  color: rgb(72, 61, 139);
}

.list-striped a:active {
  color: rgb(72, 61, 139);
}
</style>